{
  "titles": {
    "menu": "Adviseurs",
    "table": "Adviseurs",
    "create": "Adviseur aanmaken",
    "update": "Adviseur wijzigen",
    "funders": "Spaarders",
    "details": "Algemeen",
    "advisorDetails": "Adviseur details",
    "settings": "Bevoegdheden"
  },
  "fields": {
    "labels": {
      "name": "Volledige naam",
      "phone": "Telefoon",
        "email": "E-mail",
      "partnerName": "Bedrijfsnaam",
      "hasAccessToPortal": "Heeft toegang tot de app"
    },
    "descriptions": {
      "hasAccessToPortal": "Inloggen bij het partnerportaal"
    },
    "hints": {

    },
    "validationErrors": {

    }
  },
  "headers": {
    "labels": {
      "numberOfFunders": "Aantal spaarders"
    }
  },
  "messages": {
    "createSuccess": "Adviseur aangemaakt",
    "updateSuccess": "Adviseur is opgeslagen"
  },
  "actions": {
    "create": "Adviseur aanmaken",
    "update": "Adviseur aanpassen",
    "search": "Zoek een adviseur",
    "impersonate": "Inloggen als"
  }
}
